import { render, staticRenderFns } from "./RestoreShirtModal.vue?vue&type=template&id=59b406e6"
import script from "./RestoreShirtModal.vue?vue&type=script&lang=js"
export * from "./RestoreShirtModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports